// extracted by mini-css-extract-plugin
module.exports = {"modal":"jgp-2UV8M","text":"jgp-ZCPaJ"};